import { action, runInAction, autorun } from "mobx";

import { RootStore } from "@state/stores/types";

import BasePopupStore from "@state/stores/popups/BasePopupStore";
import { redirectToLogin } from "@utils/auth";

class AutomaticLogoutStore extends BasePopupStore {
	constructor(rootStore: RootStore) {
		super(rootStore);

		autorun(() => {
			if (
				this.rootStore.userAuthStore.isLoggedIn &&
				this.rootStore.userAuthStore.autoLogoutPeriod !== null
			) {
				this.startTimer();
			} else {
				this.clearTimer();
			}
		});
	}

	@action.bound
	startTimer() {
		let automaticLogoutTimeStamp: number | string | null | undefined =
			this.rootStore.userAuthStore.autoLogoutPeriod;

		if (
			automaticLogoutTimeStamp == null &&
			this.rootStore.userAuthStore.loginHistory?.currentLogin != null
		) {
			const lastLoginTimeStamp = new Date(
				this.rootStore.userAuthStore.loginHistory?.currentLogin
			).getTime();

			automaticLogoutTimeStamp =
				lastLoginTimeStamp +
				(this.rootStore.userAuthStore.autoLogoutPeriod ||
					new Date().getTime()) *
					60 *
					60 *
					1000;
		}

		if (automaticLogoutTimeStamp != null) {
			const triggerInMs = automaticLogoutTimeStamp - new Date().getTime();

			this.clearTimer();
			this.timerId = setTimeout(async () => {
				const isPrivateRouteActive =
					location.pathname.includes("account-settings") ||
					location.pathname.includes("account-statement") ||
					location.pathname.includes("my-bets");

				const deactivateRestOfThePopups = () => {
					this.rootStore.realityCheckStore.deactivatePopup();
				};

				if (
					this.rootStore.userAuthStore.isLoggedIn &&
					!this.rootStore.sessionExpireStore.isGameOpen
				) {
					runInAction(async () => {
						if (isPrivateRouteActive) {
							deactivateRestOfThePopups();
							this.deactivatePopup();
						} else {
							deactivateRestOfThePopups();
							this.activatePopup();
						}
					});

					await this.rootStore.userAuthStore.logoutUser({
						isAutomaticLogout: true,
						isRealityCheckLogout: false,
					});

					if (isPrivateRouteActive) {
						redirectToLogin("isAutomaticLogout=true");
					}
				}
			}, triggerInMs);
		}
	}
}

export default AutomaticLogoutStore;
